import { FormContainer } from "@/components/form/FormContainer";
import { useOne } from "@refinedev/core";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { RESOURCE_TYPE_ADDONS } from "@/resources-def";
import { Button, Space } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAddonSchema } from "@/resources-def/addons-comp";
import { CreationWrapper } from "@/layouts/CreationWrapper";
import { useResourceCreate } from "@/hooks/useResourceCreate";

const RESOURCE = RESOURCE_TYPE_ADDONS;

export const AddonCreator = () => {
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const navigateBack = useNavigate();
  const { mutateAsync, loading: isSaving } = useResourceCreate({
    resource: RESOURCE,
  });

  const rawSchema = getAddonSchema(true, false);

  const doCommit = async (values) => {
    await formRef.current?.validateFields();
    values.requires = JSON.stringify(values.tableData);
    delete values.tableData;
    const result = await mutateAsync({ values });
    if (result) {
      navigate({ resource: "settings/" + RESOURCE, action: "list" });
    } else {
      // TODO: show error message
    }
  };

  return (
    <CreationWrapper
      footer={
        <Space>
          <Button
            onClick={() => {
              if (window.history.length > 1) {
                navigateBack(-1);
              } else {
                navigate({ resource: "setting/" + RESOURCE, action: "list" });
              }
            }}
          >
            Cancel
          </Button>
          <Button loading={isSaving} type="primary" onClick={() => formRef.current.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      {isSaving && <div>Loading...</div>}
      {!isSaving && (
        <FormContainer
          formRef={formRef}
          initValue={{}}
          schema={rawSchema}
          onFinishCallback={doCommit}
          style={{ paddingTop: 24 }}
          formItemLayout={{
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }}
        />
      )}
    </CreationWrapper>
  );
};
